import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import SetPasswordForm from '../../../partials/SetPasswordForm';
import BackToSignIn from './BackToSignIn';
const SetNewPassword = ({ email })=>{
    const isInProgress = useSelector(selectors.isSignInInProgress);
    const signInCancel = useAction(actions.signInCancel);
    useEffect(()=>()=>{
            if (isInProgress) {
                signInCancel();
            }
        }, []);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(SetPasswordForm, {
                email: email
            }),
            /*#__PURE__*/ _jsx(BackToSignIn, {})
        ]
    });
};
export default SetNewPassword;
